import React from "react";
import DashboardSection from "../../Sections/Dashboard";
import Dashboard from "./Dashboard";
import MasterDashboard from "../../pages/MasterDashboardMUI";

const DashboardComponent = () => {
    return <Dashboard sectionName={<MasterDashboard />} />;
};

export default DashboardComponent;
